/* low-stock.js — inclinacion 3D del aviso de pocas unidades.
   Es lo unico que necesita JavaScript: el rebote y el parpadeo son CSS.
   Sin este archivo el aviso se ve y se lee igual, solo deja de inclinarse. */

(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function move(event) {
    if (reduce.matches) return;

    var el = event.currentTarget;
    var max = parseFloat(el.dataset.lsTilt) || 0;
    if (!max) return;

    var box = el.getBoundingClientRect();
    if (!box.width || !box.height) return;

    // -0.5 en un borde, 0.5 en el contrario.
    var x = (event.clientX - box.left) / box.width - 0.5;
    var y = (event.clientY - box.top) / box.height - 0.5;

    el.style.setProperty('--ls-ry', (x * max * 2).toFixed(2) + 'deg');
    el.style.setProperty('--ls-rx', (-y * max * 2).toFixed(2) + 'deg');
  }

  function reset(event) {
    var el = event.currentTarget;
    el.style.setProperty('--ls-ry', '0deg');
    el.style.setProperty('--ls-rx', '0deg');
  }

  // Delegado a proposito: la ficha se vuelve a renderizar entera al cambiar de
  // variante, asi que el nodo es OTRO cada vez y enganchar una sola vez al
  // cargar dejaria el efecto muerto tras el primer cambio de variante.
  document.addEventListener(
    'pointerover',
    function (event) {
      if (event.pointerType && event.pointerType !== 'mouse') return;

      var el = event.target.closest ? event.target.closest('.ls-badge[data-ls-tilt]') : null;
      if (!el || el.lsTiltBound) return;

      el.lsTiltBound = true;
      el.addEventListener('pointermove', move);
      el.addEventListener('pointerleave', reset);
    },
    { passive: true }
  );
})();
